import React from 'react';
import PropTypes from 'prop-types';
import Money from '../../components/Money';
import { PROMO_TYPE } from '../constants';

const PromoValue = ({ promo, ...props }) => {
  if (promo.kind === PROMO_TYPE.percentage) {
    return (<span {...props}>{promo.value}%</span>);
  }

  return (<Money cents={promo.value} {...props} />);
};
PromoValue.propTypes = {
  promo: PropTypes.shape({
    amount: PropTypes.number,
    kind: PropTypes.number,
  }).isRequired,
};

export default PromoValue;



// WEBPACK FOOTER //
// ./src/app/campaign/components/PromoValue.jsx